<!--  -->
<template>
  <div class="time_pushbox">
    <div class="strate_box">
      <div>群发标题：</div>
      <el-input v-model="pushtimevalue" style="width:200px" placeholder="请输入群发标题" />
    </div>
    <div class="strate_box">
      <div>选择平台：</div>
      <el-select v-model="promlateid" placeholder="请选择" @change="strategyplatform">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <div class="title_boxtips">
        *涉及到AB号跳转，请选择通用平台
      </div>
    </div>
    <!-- <div class="strate_box">
      <div>保留历史：</div>
      <el-select v-model="savehistoryid" placeholder="请选择">
        <el-option
          v-for="item in savehistory"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div> -->
    <div v-if="promlateid!=null" class="strate_box">
      <div class="title_box">选标签组：</div>
      <el-select v-model="labelgroupid" multiple :disabled="optionsr.length===0" placeholder="请选择" @visible-change="biaoqianzu">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.tag_group_name"
          :value="item.id"
        />
      </el-select>
      <!-- <el-button v-if="labelgroupid" style="margin-left:10px" size="mini" type="primary" @click="labelpreview ">查看标签信息</el-button> -->
    </div>
    <div v-if="promlateid!=null" class="strate_box">
      <div>*多标签组合为并且的关系</div>
    </div>
    <div class="strate_box">
      <div>关注时间：</div>
      <div>
        <el-select v-model="subscribe_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="subscribe_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="subscribetime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechanger"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>互动时间：</div>
      <div>
        <el-select v-model="interaction_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="interaction_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="interactiontime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechangerall"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>付费情况：</div>
      <div>
        <el-radio-group v-model="consumption">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">未付费</el-radio>
          <el-radio :label="2">已付费</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="strate_box">
      <div>发送时间：</div>
      <el-date-picker
        v-model="sendtime"
        :clearable="false"
        type="datetime"
        placeholder="选择日期时间"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        :picker-options="pickerOptions"
      />
    </div>

    <div class="strate_box">
      <div>定时删除：</div>
      <div>
        <br>
        <el-radio-group v-model="radio">
          <el-radio :label="0">否</el-radio>
          <br>
          <br>
          <el-radio :label="1"><el-input v-model="input" :disabled="radio == 0" type="number" min="1" max="7" style="width:70px" placeholder="天数" @blur="chaer" /><span>天 后删除该群发（输入范围1-7之间）</span></el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="strate_box">
      <div>推送方式：</div>
      <div>
        <br>
        <el-radio-group v-model="to_all">
          <el-radio :label="1">根据openid推送（公众号详情中不显示）</el-radio>
          <br>
          <br>
          <el-radio :label="3">推送全部（公众号详情中显示）</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-if="promlateid!=null" class="strate_box">
      <div>
        选择的消息：
      </div>
      <div>
        {{ messagename }}
      </div>
    </div>
    <el-select v-if="promlateid!=null" v-model="pageIfon.onlyMe" placeholder="请选择" style="margin-bottom: 10px;" @change="strategyplatformr">
      <el-option
        v-for="item in accountarr"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <div class="input-box">
      <el-input v-model="pageIfon.title" style="width:200px;" placeholder="请输入标题" />
      <el-button type="primary" icon="el-icon-search" @click="srarch">搜索</el-button>
    </div>
    <el-table
      v-if="promlateid!=null"
      ref="table"
      :key="refreshKey"
      :data="publicAdvelist"
    >
      <el-table-column
        label="选项"
        width="100"
      >
        <template slot-scope="scope">
          <input
            v-model="scope.row.checkboxFlag"
            type="checkbox"
            @click="handleChangeSelectone(scope.$index, scope.row)"
          >
          {{ scope.row.$index }}
        </template>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="平台"
        align="center"
      />
      <el-table-column
        prop="real_name"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      v-if="promlateid!=null"
      :total="total"
      :current-page="pageIfon.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div v-if="promlateid!=null" class="strate_box">
      <div>选择公众号：</div>
      <div>
        <el-tag type="warning" @click="chooseaccout">选择公众号</el-tag>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-left:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
      </div>
    </div>

    <div style="margin-top:10px">预览：</div>
    <div class="strate_box" style="margin-bottom:20px">
      <div>预览微信号：</div>
      <div>
        <el-input v-model="wechatnumber" placeholder="请输入预览微信号" />
      </div>
    </div>
    <div v-if="historyarr.length!=0" style="margin-bottom:20px">
      <span style="color: rgb(169, 162, 151);font-size:14px;display: inline-block;width: 82px;text-algin:right">历史记录：</span>
      <el-tag v-for="item,index in historyarr" :key="index" class="tag_box" @click="wechatnumber = item">{{ item }}</el-tag>
    </div>
    <div class="strate_box">
      <div>预览微信公众号：</div>
      <div>
        <el-tag v-if="appid">{{ app_name }}</el-tag>
        <el-button style="margin-left:10px" size="mini" type="primary" @click="chooserw">选择预览公众号</el-button>
        <el-button type="primary" size="mini" :loading="previewdisbled" @click="previewaccount">{{ previewdisbled ? '预览中': '预览' }}</el-button>
      </div>
    </div>

    <div>
      <el-button type="primary" size="small" @click="gobackone">返回</el-button>
      <el-button type="primary" size="small" :loading="savedisabled" @click="btnclick">{{ savedisabled ? '提交中' : '提交' }}</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" />
    </el-dialog>
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="dialogVisibleser"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <Labelgroupdialog ref="labeldialog" :optionsr="optionsr" />
    </el-dialog>
    <!-- 选择公众号弹窗 -->
    <el-dialog
      title="选择预览公众号"
      :visible.sync="lookdialogVisibleser"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <lookaccount ref="looklabeldialog" @callbackr="callbackr" />
    </el-dialog>
    <!-- 选择通用的弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="AandBdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <bandAandB ref="bandAandBview" @saveupdata="saveupdata" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败列表"
      :visible.sync="erroraccount"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" @emptyaccount="emptyaccount" />
    </el-dialog>
  </div>
</template>

<script>
import { strategyPlatform, accountlist, gerwinda, adminlist, articlepreview, historyWechatNo } from '@/api/sourceMaterial.js'
import ChooseaccountDialog from '../timedPush/components/ChooseaccountDialog.vue'
import Labelgroupdialog from '../customerServicelist/components/Labelgroupdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import lookaccount from './components/lookaccount.vue'
import bandAandB from '../customerServicelist/components/bandAandB.vue'
import errorlist from '../redEnvelopeActivity/components/errorlist.vue'
export default {
  components: {
    ChooseaccountDialog,
    PaginationRight,
    Labelgroupdialog,
    lookaccount,
    bandAandB,
    errorlist
  },
  data() {
    return {
      interaction_time_type: 0,
      interactiontime: [],
      interaction_time_from: '',
      interaction_time_to: '',
      subscribetime: [],
      subscribe_time_from: '',
      subscribe_time_to: '',
      subscribe_time_type: 0,
      consumption: 0,
      optionsrr: [{
        value: 0,
        label: '不限'
      }, {
        value: 8,
        label: '24小时内'
      }, {
        value: 1,
        label: '2天(48小时)以内'
      }, {
        value: 2,
        label: '2天(48小时)前'
      }, {
        value: 3,
        label: '2至7天'
      }, {
        value: 4,
        label: '7天内'
      }, {
        value: 5,
        label: '7天前'
      }, {
        value: 6,
        label: '今天前'
      },
      {
        value: 7,
        label: '自定义'
      }],
      pushtimevalue: '', // 群发标题
      options: [], // 平台数组
      promlateid: null, // 平台id
      sendtime: null, // 发送时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      arrs: [], // 选择公众号数组
      arrsw: [], // 选择公众号数组 id集合
      dialogVisible: false,
      dialogVisibleser: false,
      messagename: '', // 消息名称
      messageid: null, // 消息id
      publicAdvelist: [], // 列表数组
      refreshKey: 0, // 客服消息key
      total: null, // 总页数
      pageIfon: {
        page: 1,
        pageSize: 10,
        platform_id: this.promlateid,
        onlyMe: 2,
        title: ''
      },
      optionsr: [], // 选择标签组数组
      labelgroupid: [], // 标签组id
      wechatnumber: '', // 预览微信号
      radio: 0,
      input: '',
      num: null, // 天数传值
      lookdialogVisibleser: false,
      appid: null,
      app_name: '',
      savehistoryid: null,
      savehistory: [
        {
          id: 1,
          name: '保留'
        },
        {
          id: 2,
          name: '不保留'
        }
      ],
      previewdisbled: false,
      savedisabled: false,
      AandBdialogVisible: false,
      erroraccount: false,
      failsarr: [],
      allarr: [],
      historyarr: [],
      to_all: 1,
      accountarr: [{
        value: 1,
        label: '查看组内消息'
      }, {
        value: 2,
        label: '我关联的消息'
      }]
    }
  },

  created() {
    this.getstrategyplatformlist()
    this.historylist()
    this.optionsr.push({
      id: 0,
      tag_group_name: '全部'
    })
  },
  mounted() {

  },
  methods: {
    timechanger(val) {
      this.subscribe_time_from = val[0]
      this.subscribe_time_to = val[1]
      console.log('val', val)
    },
    timechangerall(val) {
      this.interaction_time_from = val[0]
      this.interaction_time_to = val[1]
      console.log('val', val)
    },
    // 获取历史记录
    async historylist() {
      const data = await historyWechatNo()
      this.historyarr = data.data ? data.data : []
      console.log('data', data)
    },
    // 获取列表
    async getliser() {
      const data = await accountlist(this.pageIfon)
      this.publicAdvelist = data.data.list
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
        if (item.id === this.messageid) {
          item.checkboxFlag = true
        }
      })
      this.total = data.data.total
    },
    saveupdata() {
      this.AandBdialogVisible = false
      this.$router.push({ path: '/officialaccountempush/index' })
      this.getliser()
    },
    // 客服消息单选
    handleChangeSelectone(index) {
      if (!this.publicAdvelist[index].checkboxFlag) {
        this.messagename = this.publicAdvelist[index].title
        this.messageid = this.publicAdvelist[index].id
      } else {
        // this.selectData = null
      }
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvelist[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 获取策略平台
    async getstrategyplatformlist() {
      const data = await strategyPlatform()
      this.options = data.data.list
    },
    rightclick(id, index) {
      this.arrs.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },
    chooseaccout() {
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.messagename === '') {
        this.$message.error('请选择消息')
        return
      }
      this.dialogVisible = true
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, this.messageid, null, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.arrs, this.messageid, null, 2)
        }, 100)
      }
    },
    // 选择完公众号 回调
    closedialog(arr) {
      this.arrs = arr
      this.dialogVisible = false
      console.log('arr', arr)
    },
    // // 选择完公众号id回调
    // closedialogone(arr) {
    //   this.arrs = arr
    // },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getliser()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getliser()
    },
    srarch() {
      this.pageIfon.page = 1
      this.getliser()
    },
    // 提交
    async btnclick() {
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
      console.log('radio', this.radio)
      if (this.pushtimevalue === '') {
        this.$message.error('请输入群发标题')
        return
      }
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      // if (this.savehistoryid === null) {
      //   this.$message.error('请选择是否保留历史')
      //   return
      // }
      if (this.labelgroupid.length === 0) {
        this.$message.error('请选择标签组')
        return
      }
      if (this.sendtime === null) {
        this.$message.error('请选择发送时间')
        return
      }
      if (this.subscribe_time_type === null) {
        this.$message.error('请选择关注时间')
        return
      }
      if (this.interaction_time_type === null) {
        this.$message.error('请选择互动时间')
        return
      }
      if (this.subscribe_time_type === 7) {
        if (this.subscribetime.length === 0) {
          this.$message.error('请选择自定义时间范围')
          return
        }
      }
      if (this.interaction_time_type === 7) {
        if (this.interactiontime.length === 0) {
          this.$message.error('请选择自定义时间范围')
          return
        }
      }
      // if (this.wechatnumber === '') {
      //   this.$message.error('请选择预览微信号')
      //   return
      // }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 1 && this.input == '') {
        this.$message.error('请填写天数')
        return
      }

      if (this.arrsw.length === 0) {
        this.$message.error('请选择公众号')
        return
      }
      if (this.messageid === null) {
        this.$message.error('请选择要推送的消息')
        return
      }

      console.log('this.arrsw', this.arrsw)
      this.num = null
      // eslint-disable-next-line eqeqeq
      if (this.radio == 0) {
        this.num = 0
        console.log('否', this.num)
      } else {
        this.num = this.input
        console.log('是', this.num)
      }
      const parms = {}
      if (this.subscribe_time_type === 7) {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.subscribe_time_from = this.subscribe_time_from
        parms.subscribe_time_to = this.subscribe_time_to
        parms.consumption = this.consumption
      } else {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.consumption = this.consumption
      }
      const huparms = {}
      if (this.interaction_time_type === 7) {
        huparms.interaction_time_type = this.interaction_time_type
        huparms.interaction_time_from = this.interaction_time_from
        huparms.interaction_time_to = this.interaction_time_to
      } else {
        huparms.interaction_time_type = this.interaction_time_type
      }
      try {
        this.savedisabled = true
        const data = await gerwinda({
          app_ids: this.arrsw,
          articles_template_id: this.messageid,
          send_time: this.sendtime,
          platform_id: this.promlateid,
          tag_group_ids: this.labelgroupid,
          timing_del: this.num,
          ...parms,
          ...huparms,
          title: this.pushtimevalue,
          to_all: this.to_all
        // retain_history: this.savehistoryid
        // preview_wechat_no: this.wechatnumber
        })

        // eslint-disable-next-line eqeqeq
        // if (this.promlateid == 99) {
        //   console.log('选择通用')
        //   this.AandBdialogVisible = true
        //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        //     this.$refs.bandAandBview.send(data.data.choosing, this.messageid, this.arrsw, 3, this.sendtime, this.promlateid, this.labelgroupid, this.num)
        //   }, 100)
        // } else {
        //   this.$router.go(-1)
        //   if (data.data.failed.length !== 0) {
        //     this.$message({
        //       type: 'error',
        //       message: `绑定失败的公众号:${data.data.failed.join(',')}`
        //     })
        //   } else {
        //     this.$message({
        //       type: 'success',
        //       message: '新增成功'
        //     })
        //   }
        //   console.log('data', data.data.failed)
        // }
        if (data.code === 204) {
          console.log('绑定有问题', data.data.fails)
          this.savedisabled = false
          this.erroraccount = true
          this.failsarr = []
          this.failsarr = data.data.fails
          this.$nextTick(() => { // 请求成功之后，在这里执行
            this.$refs.errorlistview.send(data.data.fails, 1)
          })
        }
        if (data.data == null) {
          this.$message({
            type: 'success',
            message: `${data.message}`
          })
          this.savedisabled = false
          this.$router.go(-1)
        }
      } catch (e) {
        this.savedisabled = false
        console.log('发生异常:' + e)
      }
    },
    emptyaccount() {
      this.erroraccount = false
      console.log(this.arrs)
      console.log(this.failsarr)
      this.allarr = []
      // eslint-disable-next-line eqeqeq
      this.allarr = this.arrs.filter(x => this.failsarr.every(y => y.app_id != x.id))
      console.log('this.allarr', this.allarr)
      this.arrs = this.allarr
      this.dialogVisible = true
      console.log('this.arrs', this.arrs)
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr, this.messageid, null, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chhoseaccout.sendrs(this.promlateid, this.allarr, this.messageid, null, 2)
        }, 100)
      }
    },
    // 返回
    gobackone() {
      this.$router.go(-1)
    },
    async strategyplatform(val) {
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: val
      })
      this.optionsr = []
      this.optionsr = data.data.list
      if (this.labelgroupid !== 0) {
        this.labelgroupid = null
      }
      this.optionsr.unshift({
        id: 0,
        tag_group_name: '全部'
      })
      this.labelgroupid = [0]
      this.arrs = []
      this.pageIfon.page = 1
      this.pageIfon.platform_id = val// 获取消息列表 给id赋值
      this.getliser()// 调用消息列表
      this.messagename = ''
      this.messageid = null
      console.log('data', data)
    },
    strategyplatformr() {
      this.arrs = []
      this.pageIfon.page = 1
      this.getliser()// 调用消息列表
      this.messagename = ''
      this.messageid = null
    },
    // 预览标签组
    labelpreview() {
      this.dialogVisibleser = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.labeldialog.labelsend(this.labelgroupid)
      }, 100)
    },
    chaer() {
      if (this.input < 0) {
        this.input = 1
      }
      // 判断不能输入小数点
      const str = '' + this.input
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.input = 1
      }
      if (this.input > 7) {
        this.input = 7
      }
    },
    chooserw() {
      if (this.promlateid === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.messagename === '') {
        this.$message.error('请选择消息')
        return
      }
      this.lookdialogVisibleser = true
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.looklabeldialog.send(this.promlateid, this.messageid)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.looklabeldialog.send(this.promlateid, this.messageid)
        }, 100)
      }
    },
    callbackr(item) {
      this.lookdialogVisibleser = false
      this.appid = item.app_id
      this.app_name = item.account_name
    },
    previewaccount() {
      if (this.messageid === null) {
        this.$message.error('请选择要预览的消息')
        return
      }
      if (this.wechatnumber === '') {
        this.$message.error('请输入预览微信号')
        return
      }
      if (this.appid === null) {
        this.$message.error('请选择预览的微信公众号')
        return
      }
      this.previewdisbled = true
      // eslint-disable-next-line eqeqeq
      if (this.promlateid == 99) {
        articlepreview({
          articles_template_id: this.messageid,
          app_id: this.appid,
          preview_wechat_no: this.wechatnumber,
          platform_id: this.promlateid,
          for_push_list: 1
        }).then((res) => {
          this.previewdisbled = false
          this.$message({
            type: 'success',
            message: '预览成功，请查看手机'
          })
        }).catch(err => {
          console.log(err)
          this.previewdisbled = false
        })
      } else {
        articlepreview({
          articles_template_id: this.messageid,
          app_id: this.appid,
          preview_wechat_no: this.wechatnumber,
          platform_id: this.promlateid
        }).then((res) => {
          this.previewdisbled = false
          this.$message({
            type: 'success',
            message: '预览成功，请查看手机'
          })
        }).catch(err => {
          console.log(err)
          this.previewdisbled = false
        })
      }
    },
    biaoqianzu() {
      console.log('this.labelgroupid', this.labelgroupid)
      for (let i = 0; i < this.labelgroupid.length; i++) {
        if (this.labelgroupid[i] === 0) {
          this.labelgroupid = [0]
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.time_pushbox{
  padding: 20px;
}
.strate_box{
  display: flex;
  align-items: center;
  gap:10px;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
   span{
      margin-left: 10px;
   }
}
.title_boxtips{
    color: #F56C6C !important;
    margin-left: 10px;
}
.tag_box{
  margin-right: 10px;
  cursor: pointer;
}
.input-box{
  display:flex;
  gap:10px;
  margin-bottom:20px;
}
</style>
